import i18nFactory from '@yandex-int/i18n';

import { GroupsMutationExecutor } from '../../api/groups/GroupsMutationExecutor';
import { getDNAApolloClient } from '../../declarations/apollo';
import { CreateTextAdGroup_addTextAdGroups_addedAdGroupItems } from '../../typings/graphql-grid';
import { getCSRFToken } from '../ApiHelpers/ApiHelpers';

import * as keyset from './mutationHelpers.i18n';

const i18n = i18nFactory(keyset);

export const getGroupsMutationExecutor = (
    login: string
): GroupsMutationExecutor => {
    const dnaClient = getDNAApolloClient(login, getCSRFToken);

    return new GroupsMutationExecutor(dnaClient);
};

export const createTextAdGroup = (
    mutationExecutor: GroupsMutationExecutor,
    {
        login,
        campaignId,
        name
    }: { login: string; campaignId: string; name: string }
): Promise<CreateTextAdGroup_addTextAdGroups_addedAdGroupItems> => {
    return mutationExecutor
        .createTextGroup({ campaignId, name }, login)
        .then(({ data }) => {
            if (!data || !data.addTextAdGroups) {
                throw new Error();
            }

            const { validationResult } = data.addTextAdGroups;
            if (validationResult && validationResult.errors.length) {
                const [firstError] = validationResult.errors;
                switch (firstError.code) {
                    case 'AdGroupDefectIds.Number.MAX_ADGROUPS_IN_CAMPAIGN':
                        throw new Error(i18n('max-adgroups-in-campaign'));
                    case 'AdGroupDefectIds.Gen.INCONSISTENT_AD_GROUP_TYPE_TO_CAMPAIGN_TYPE':
                        throw new Error(
                            i18n('inconsistent-ad-group-type-to-campaign-type')
                        );
                    case 'StringDefectIds.MUST_CONTAIN_ONLY_SYMBOLS':
                        throw new Error(i18n('name-prohibited-symbols'));
                    default:
                        throw new Error();
                }
            }

            const [createdGroupData] = data.addTextAdGroups.addedAdGroupItems;

            if (!createdGroupData || !createdGroupData.adGroupId) {
                throw new Error();
            }

            return createdGroupData;
        });
};
